import Player from '@vimeo/player'

Element.prototype.remove = function() {
  this.parentElement.removeChild(this)
}
NodeList.prototype.remove = HTMLCollection.prototype.remove = function() {
  for (var i = this.length - 1; i >= 0; i--) {
    if (this[i] && this[i].parentElement) {
      this[i].parentElement.removeChild(this[i])
    }
  }
}

const iframe = document.getElementById('iframe')

iframe.style.cursor = 'pointer'
const player = new Player('iframe', {
  id: 391290205,
})

player.on('play', function() {
  iframe.style.opacity = '1'
})
